module.exports = __webpack_public_path__ + "static/media/resham-title.60e9b9cf.jpg";